import axios from 'http.service';
import apiErrorMsg from 'Common/Utils/apiErrorMsg';

const baseUrl = '/api/v2/reset';

export const getAllRejectedByYearAndSearch = async (year, searchid, errorCb) => {
	const {
		status,
		data: { data, errors }
    } = await axios.get(baseUrl + '/all/' + year + '/' + searchid);
	if (status === 200) {
		return data;
    }
	const errorMessage = apiErrorMsg(status, errors);
	return errorCb(errorMessage);
};
export async function resetRejection(dto, errorCb) {

	try {
		const { status } = await axios.put(baseUrl, dto);
		if (status === 200) return status;
	  }
	  catch(err) {
		
	  }
	
	return false;
}
